<div class="login-container">
  <p class="text-center app-logo"><img src="{{ 'APP.LOGO' | translate }}" width="300" alt="logo"/></p>
  <form class="login-form" novalidate (ngSubmit)="onSubmit(user)" [formGroup]="user">
    <input required formControlName="username" #userNameInput
           id="login-username"
           name="username"
           type="email"
           class="form-control"
           placeholder="Email" novalidate/>

    <input required #passwordInput
           formControlName="password"
           id="login-password"
           name="password"
           type="password"
           class="form-control last-field"
           placeholder="Password" novalidate/>
    <button class="btn btn-default"
            id="login-submit"
            type="submit">{{'LOGIN.login_btn' | translate}}</button>

    <p *ngIf="errorMessage" class="register-new-account-link">
      <span class="error" [innerHTML]="errorMessage"></span>
    </p>

    <p><a class="forgot-password" (click)="forgotPassword()">{{'LOGIN.forgot_password' | translate}}</a></p>
  </form>
</div>


// WEBPACK FOOTER //
// ./src/app/auth/login/login.component.html